import { defineMessages } from 'react-intl';

const trns = defineMessages({
  searchContainerHeaderLabel: {
    id: 'hXgCCs',
    defaultMessage:
      'РЕКЛАМНЕ ПОЛЕ, КУДИ МОЖНА ЗАВАНТАЖУВАТИ ВІДЕО, РЕКЛАМНІ БАННЕРА, СЛАЙДЕР'
  },
  searchContainerHeaderLabelBig: {
    id: 'WfsHqF',
    defaultMessage: 'ТЕКСТ УТП'
  },
  searchResultsInCity: {
    id: 'gThNAg',
    defaultMessage: 'Результати пошуку «{searchValue}» у '
  },
  searchResultsCity: {
    id: 'HpDIyJ',
    defaultMessage: '{userLocation}'
  },
  checkAll: {
    id: 'BT4SZi',
    defaultMessage: 'ПЕРЕГЛЯНУТИ ВСІ'
  },
  loadMoreDrugs: {
    id: 'NtfO+k',
    defaultMessage: 'ЗАВАНТАЖИТИ ЩЕ БІЛЬШЕ ЛІКІВ'
  },
  priceFilterLabel: {
    id: 'XEfY12',
    defaultMessage: 'Ціна препаратів'
  },
  applyFilters: {
    id: 'xXEKYP',
    defaultMessage: 'ЗАСТОСУВАТИ'
  },
  ok: {
    id: 'kAEQyV',
    defaultMessage: 'OK'
  },
  removeAllFilters: {
    id: 'YLjU05',
    defaultMessage: 'Скинути всі'
  },
  sort: {
    id: 'lXfNVX',
    defaultMessage: 'Сортування'
  },
  desc: {
    id: 'JR8ATG',
    defaultMessage: 'за спаданням'
  },
  asc: {
    id: 'EMEa4f',
    defaultMessage: 'за зростанням'
  },
  byName: {
    id: 'ilM7RD',
    defaultMessage: "За ім'ям {sortDirection}"
  },
  byPopular: {
    id: 'vPbue3',
    defaultMessage: 'За популярністю {sortDirection}'
  },
  byRelevance: {
    id: 'AdORwm',
    defaultMessage: 'За релевантністю {sortDirection}'
  },
  byPrice: {
    id: 'fj+EoB',
    defaultMessage: 'За ціною {sortDirection}'
  },
  descriptionTab: {
    id: 'm7BuqO',
    defaultMessage: 'Опис'
  },
  sertificatesTab: {
    id: 'L2wBfH',
    defaultMessage: 'Сертифікати'
  },
  analogsTab: {
    id: '+dac6n',
    defaultMessage: 'Аналоги'
  },
  diagnosesTab: {
    id: 'icklVo',
    defaultMessage: 'Діагнози'
  },
  reviewsTab: {
    id: 'rom88H',
    defaultMessage: 'Відгуки'
  },
  homeBreadCrumb: {
    id: '/YV5ee',
    defaultMessage: 'Головна'
  },
  searchBreadCrumb: {
    id: '9nHuel',
    defaultMessage: 'Пошук'
  },
  didntFindDescription1: {
    id: 'KUi86s',
    defaultMessage: 'спробуйте скорегувати свій запит'
  },
  changeYourRequest: {
    id: 'aOG5g2',
    defaultMessage: 'або переходьте на {link}'
  },
  catalog: {
    id: 'aPakH7',
    defaultMessage: 'КАТАЛОГ ЛІКІВ'
  },
  home: {
    id: 'Zix07W',
    defaultMessage: 'ГОЛОВНУ'
  },
  openAllFilters: {
    id: 'WjOBsH',
    defaultMessage: 'Розгорнути всі'
  },
  hideFilters: {
    id: 'f/WfD8',
    defaultMessage: 'Згорнути'
  },
  searchInFilters: {
    id: 'guRZVJ',
    defaultMessage: 'Пошук за {name}'
  },
  productsFound: {
    id: 'j7A00J',
    defaultMessage: '{count} товарів знайдено'
  },
  sortByPrice: {
    id: 'ApfijL',
    defaultMessage: 'За ціною'
  },
  sortByName: {
    id: 'qQEqq3',
    defaultMessage: 'За назвою'
  },
  sortByPopular: {
    id: '2E9dYG',
    defaultMessage: 'За популярністю'
  },
  sortByRelevance: {
    id: '1Fd4dV',
    defaultMessage: 'За релевантністю'
  },
  filter: {
    id: 'q2SZLN',
    defaultMessage: 'Фільтр'
  },
  drug: {
    id: '3uHhjS',
    defaultMessage: '«{drug}»'
  },
  drugInCity: {
    id: 'iOIXn4',
    defaultMessage: 'в аптеках міста'
  },
  priceFrom: {
    id: 'uaDDy1',
    defaultMessage: 'Ціна від'
  },
  priceTo: {
    id: '5a4Cd6',
    defaultMessage: 'Ціна до'
  },
  notInStock: {
    id: 'OHBdKC',
    defaultMessage: 'Кажуть, що зараз товарів «{drug}» в Україні не знайдеш :('
  },
  notLeftWithout: {
    id: 'Lh5F3u',
    defaultMessage: 'Але ви не залишитеся без потрібних ліків!'
  },
  viewAnalogues: {
    id: 'xtr0Cd',
    defaultMessage: 'Подивитись аналоги'
  },
  findDrugsNearby: {
    id: 'z0P/27',
    defaultMessage: 'Знайдіть ліки за вигідною ціною в аптеках поруч'
  },
  pharmacies: {
    id: 'EPQ35E',
    defaultMessage: '{quantity} аптек'
  },
  economy: {
    id: 'muGp2V',
    defaultMessage: 'до {percents} економії'
  },
  goods: {
    id: 'sL3iK2',
    defaultMessage: '{quantity} товарів'
  }
});

export default trns;
